import { productIdFormat } from "@redotech/redo-product-id";
import * as z from "zod";

export const bulkUpdateReplenishmentSettings = {
  name: "bulkUpdateReplenishmentSettings" as const,
  input: z
    .object({
      productIds: z.array(productIdFormat.schema).min(1),
      defaultReplenishmentQuantity: z
        .number()
        .int()
        .min(1)
        .nullable()
        .optional(),
      minimumPickable: z.number().int().min(0).nullable().optional(),
    })
    .refine(
      (input) =>
        input.defaultReplenishmentQuantity !== undefined ||
        input.minimumPickable !== undefined,
      { message: "Nothing to update" },
    ),
  output: z.object({
    updatedCount: z.number(),
    skippedNoAuthCount: z.number(),
    locationCount: z.number(),
  }),
};
